/**
 * 运行时租户 code — 与构建配置 / Host 解析一致。
 */
import { getConfiguredTenantCode } from '@/config/tenant-site'

/** 当前 API 请求携带的租户 code */
export function getActiveTenantCode(): string {
  return getConfiguredTenantCode()
}

export function isMultiTenantMode(mode?: string): boolean {
  return mode === 'multi'
}
